import { WBBox } from "@apptractive/design-system-web";
import { Outlet } from "react-router-dom";
import { ChangeLanguage } from "./ChangeLanguage";
import { NavBar } from "./common";
import { PageContainer } from "./PageContainer";

const UnAuthLayout = () => {
  return (
    <WBBox height="100vh">
      <NavBar navRight={<ChangeLanguage />} />
      <PageContainer sx={{ height: "calc(100vh - 64px)" }}>
        <Outlet />
      </PageContainer>
    </WBBox>
  );
};

export default UnAuthLayout;
